"use client";

import { LockKeyhole, Users } from "lucide-react";
import { Button } from "@/components/ui/button";

export function NewSessionSharing(props: {
  channelId: string | null;
  channelName?: string;
  shared: boolean;
  disabled: boolean;
  onChange: (shared: boolean) => void;
}) {
  const channelBound = Boolean(props.channelId);
  const shared = channelBound || props.shared;
  const description = channelBound
    ? `Everyone with access to ${props.channelName || "this channel"} can read this session.`
    : shared
      ? "Shared with the organisation. Click to make private."
      : "Private conversation. Click to share with the organisation.";
  const Icon = shared ? Users : LockKeyhole;
  return (
    <Button
      type="button"
      variant="ghost"
      size="sm"
      className="h-8 shrink-0 gap-1.5 rounded-md px-2 text-xs text-muted-foreground"
      disabled={props.disabled || channelBound}
      title={description}
      aria-label={channelBound ? description : "Share session with organisation"}
      aria-pressed={shared}
      onClick={() => props.onChange(!props.shared)}
    >
      <Icon className="size-3.5" aria-hidden />
      {channelBound ? "Channel" : shared ? "Shared" : "Private"}
    </Button>
  );
}
